import { createI18n } from "vue-i18n";
import { loadLocaleMessages } from "@/utils/api/loadLocaleMessages";
import { getLanguage } from "@/utils/api/getLanguage";
import { config } from "./config";

const i18n = createI18n({
  legacy: false,
  globalInjection: true,
  locale: getLanguage(),
  fallbackLocale: config.constants.DEFAULT_LANG,
  messages: loadLocaleMessages(),
});

export default i18n;
